import { Component, Element, Prop, Watch, h } from '@stencil/core';

import imageCaptureActions from '../actions/actions.image-capture';
import { state as imageCaptureState, on as onImageCaptureStateChange } from '../store/store.image-capture';
import { ImageCaptureEvents, trackImageCapture } from '../tracking/tracking.imageCapture';

@Component({
  tag: 'image-capture-hydrator',
  shadow: true,
})
export class ImageCaptureHydrator {
  @Element() el: HTMLElement;

  @Prop() imageGroupGuid = '';
  @Prop() requiresAllPhotos = false;
  @Prop() shouldShowError = false;

  @Prop() theme: string;

  @Watch('shouldShowError')
  shouldShowErrorWatcher() {
    imageCaptureActions.onStoreUpdate({ shouldShowError: this.shouldShowError });
  }

  async componentWillLoad() {
    trackImageCapture(ImageCaptureEvents.Impression, 'impression');
    // boostrap props
    imageCaptureActions.onReceivedParams({
      imageGroupGuid: this.imageGroupGuid,
      requiresAllPhotos: this.requiresAllPhotos,
      shouldShowError: this.shouldShowError,
    });

    await imageCaptureActions.onLoadImages(this.imageGroupGuid);

    this.setupStateProps();

    onImageCaptureStateChange('set', (prop, value) => {
      this.updateStateProps(prop, value);
    });
  }
  // updates only the changed prop
  updateStateProps(prop, value) {
    this.el.childNodes.forEach((element) => {
      element[prop] = value;
    });
  }

  // explicitly declare initial state props
  setupStateProps() {
    this.el.childNodes.forEach((element) => {
      element['imageGroupGuid'] = imageCaptureState.imageGroupGuid;
      element['imageUrls'] = imageCaptureState.imageUrls;
      element['requiresAllPhotos'] = imageCaptureState.requiresAllPhotos;
      element['shouldShowError'] = imageCaptureState.shouldShowError;

      element['theme'] = this.theme;
    });
  }

  render() {
    return (
      <div class="hydration-state hydration-state--image-capture">
        <slot />
      </div>
    );
  }
}
